'use client'

import Image from 'next/image'

interface TripImageProps {
  imageUrl?: string | null
  alt: string
  className?: string
  aspectRatio?: number
  showFallback?: boolean
}

export default function TripImage({
  imageUrl,
  alt,
  className = '',
  aspectRatio = 16 / 9,
  showFallback = true
}: TripImageProps) {
  if (!imageUrl) {
    if (!showFallback) return null
    
    return (
      <div 
        className={`bg-gradient-to-br from-mullins-100 to-mullins-200 flex items-center justify-center ${className}`}
        style={{ aspectRatio }}
      >
        <div className="text-center text-mullins-600">
          <svg className="mx-auto h-12 w-12 mb-2" stroke="currentColor" fill="none" viewBox="0 0 48 48">
            <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <p className="text-sm font-medium">No Image</p>
        </div>
      </div>
    )
  }

  return (
    <div className={`relative overflow-hidden rounded-lg ${className}`} style={{ aspectRatio }}>
      <Image
        src={imageUrl}
        alt={alt}
        fill
        className="object-cover rounded-lg"
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
        onError={(e) => {
          // Fallback to placeholder on error
          const target = e.target as HTMLImageElement
          target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect fill='%23e5e7eb' width='400' height='300'/%3E%3Ctext fill='%239ca3af' font-family='sans-serif' font-size='20' dy='10.5' font-weight='bold' x='50%25' y='50%25' text-anchor='middle'%3ENo Image%3C/text%3E%3C/svg%3E"
        }}
      />
    </div>
  )
}
